import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import { useFormData } from "../context/FormDataContext";
import { API_BASE as AUTH_API_BASE } from "../auth/authClient";

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #444",
  outline: "none",
  fontSize: 14,
};

const boxStyle = { border: "1px solid #333", borderRadius: 12, padding: 12, marginBottom: 12 };
const labelStyle = { fontSize: 13, fontWeight: 800, marginBottom: 6 };
const btnStyle = { padding: "9px 12px", borderRadius: 10, border: "1px solid #444", cursor: "pointer", fontWeight: 900 };

const mk = (i) => ({ id: `prevoz${i + 1}`, od: "", kam: "", km: "", zpCount: false, sTelem: false });

const norm = (x) => {
  const o = x && typeof x === "object" ? { ...x } : {};
  if (!o.od && o.umrtiAddress) o.od = o.umrtiAddress;
  if (!o.kam && o.toAddress) o.kam = o.toAddress;
  if (!o.od && o.fromAddress) o.od = o.fromAddress;
  if (!o.kam && o.to) o.kam = o.to;  if (!o.kam && o.do) o.kam = o.do;

  return o;
};

// vezme N položek z prevozy[], a když nejsou, tak použije legacy formData.prevoz jako první
const ensureN = (fd, n = 5) => {
  const arrRaw = Array.isArray(fd?.prevozy) ? fd.prevozy : [];
  const legacy = fd?.prevoz && typeof fd.prevoz === "object" ? fd.prevoz : null;

  const out = Array.from({ length: n }, (_, i) => ({ ...mk(i), ...norm(arrRaw[i] || {}) }));
  if (legacy && (!arrRaw[0] || (!norm(arrRaw[0]).od && !norm(arrRaw[0]).kam && !norm(arrRaw[0]).km))) {
    out[0] = { ...out[0], ...norm(legacy) };
  }
  return out;
};

// API base (sjednoceno): zdroj pravdy = authClient API_BASE (které čte VITE_API_BASE_URL)
const API_BASE = String(AUTH_API_BASE || "").replace(/\/+$/, "");
const apiUrl = (path) => (API_BASE ? `${API_BASE}${path}` : path);
function __resolveMistoUmrti(formData) {
  // Primárně Vstupní informace (vi), pak root, pak vyjezd, pak prevoz
  const vi = formData?.vstupniInformace || formData?.vstupniInfo || formData?.vstupni || formData?.vi || {};
  const vy = formData?.vyjezd || {};

  const v = pickStr(
    vi?.adresaUmrti, vi?.mistoUmrti, vi?.umisteniUmrti,
    formData?.adresaUmrti, formData?.mistoUmrti,
    vy?.adresaUmrti, vy?.mistoUmrti, vy?.umrtiAddress,
    formData?.prevoz?.mistoUmrti, formData?.prevoz?.adresaUmrti
  );

  return String(v || "").trim();
}



const pickStr = (...vals) => {
  for (const v of vals) {
    const s = String(v ?? "").trim();
    if (s) return s;
  }
  return "";
};
const floorKm = (v) => Math.max(0, Math.floor(Number(v || 0) || 0));





// ✅ Km k účtování (pro doprava_1km)
// Komerční: Celkem km
// ZP: Objednavatel km (ZP část se neúčtuje)
const calcKmKuctovat = (fd, totalKmMemo) => {
  const pre = fd?.prevoz || {};
  const rez = String(pre?.rezim || "komercni").toLowerCase();
  const isZP = rez.includes("zp") || rez.includes("poj");

  const total = Math.max(0, Math.floor(Number(totalKmMemo || 0) || 0));
  const objed = Math.max(0, Math.floor(Number(pre?.objednavatelKm ?? pre?.kmUctovat ?? 0) || 0));

  return isZP ? objed : total;
};

function __toNum(v) {
  const n = Number(v ?? 0);
  return Number.isFinite(n) ? n : 0;
}
function __floorKm2(v) {
  return Math.max(0, Math.floor(__toNum(v)));
}
function __list(arr) {
  return Array.isArray(arr) ? arr.slice() : [];
}
function __upsertDoprava1km(sluzbyArr, km, { removeWhenZero = false } = {}) {
  const kmInt = __floorKm2(km);
  const id = "doprava_1km";
  const arr = __list(sluzbyArr);
  const idx = arr.findIndex((x) => String(x?.id || "") === id);

  if (removeWhenZero && kmInt <= 0) {
    if (idx >= 0) arr.splice(idx, 1);
    return arr;
  }

  if (idx >= 0) {
    const cur = arr[idx] || {};
    // respektuj ruční lock (když existuje)
    if (cur?.manualQty === true) {  /* placeholder */ }
    // JS nemá true, nahradíme:
  }
  return arr;
}




export default function PrevozForm() {
  
  // === ZP: km k účtování (místo úmrtí → patologie) přes Mapy.com ===
  const [kmZpInfo, setKmZpInfo] = useState({ state: "idle", msg: "" });

  const [showAdvanced, setShowAdvanced] = useState(false);
  const __isZP = () => {
    const rez = String(formData?.prevoz?.rezimZP ?? formData?.prevoz?.rezim ?? "").toLowerCase();
    return rez.includes("zp") || rez.includes("poj") || rez.includes("poji");
  };

  const __getToken = () => {
  const read = (store) => {
    try {
      return (
        store.getItem("token") ||
        store.getItem("authToken") ||
        store.getItem("accessToken") ||
        store.getItem("pohrebka_token") ||
        store.getItem("pspohrebka_token") ||
        store.getItem("pohrebkaToken") ||
        store.getItem("PAPI_TOKEN") ||
        store.getItem("API_TOKEN") ||
        ""
      );
    } catch {
      return "";
    }
  };

  const raw = String(read(localStorage) || read(sessionStorage) || "").trim();
  if (!raw) return "";

  // někdy je uložené jako "Bearer xxx"
  return raw.startsWith("Bearer ") ? raw.slice(7).trim() : raw;
};

  const __resolveMistoUmrti = () => {
  // Primárně Vstupní informace, pak root, pak Výjezd, pak prevoz
  const vi =
    formData?.vstupniInformace ||
    formData?.vstupniInfo ||
    formData?.vstupniUdaje ||
    formData?.vstupni ||
    formData?.vi ||
    {};

  const vy = formData?.vyjezd || {};
  const pre = formData?.prevoz || {};

  const pick = (...vals) => {
    for (const v of vals) {
      const t = String(v ?? "").trim();
      if (t) return t;
    }
    return "";
  };

  return pick(
    // Vstupní informace (nejdůležitější)
    vi?.adresaUmrti, vi?.mistoUmrti, vi?.umisteniUmrti,
    vi?.adresa_umrti, vi?.misto_umrti,

    // root fallback (kdyby někde ukládal přímo do rootu)
    formData?.adresaUmrti, formData?.mistoUmrti,

    // výjezd fallback
    vy?.adresaUmrti, vy?.mistoUmrti, vy?.umrtiAddress,

    // prevoz fallback (když už je někde ručně vyplněno)
    pre?.mistoUmrti, pre?.adresaUmrti
  );
};

  const __kmMapyZP = async (opts = {}) => {
  const prevozNow = formData?.prevoz || {};
  const from = String(opts?.from ?? prevozNow?.zpPitvaFrom ?? __resolveMistoUmrti() ?? "").trim();
  const to = String(opts?.to ?? prevozNow?.zpPitvaTo ?? "").trim();
if (!from || !to) {
      setKmZpInfo({ state: "err", msg: "Chybí 'místo úmrtí' nebo 'patologie'." });
      return;
    }

    setKmZpInfo({ state: "saving", msg: "Počítám…" });

    const token = __getToken();
    const r = await fetch("/api/vypocitej-km", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ umrtiAddress: from, toAddress: to, routeType: "car_fast" }),
    });

    const data = await r.json().catch(() => ({}));
    if (!r.ok || !data?.ok) {
      setKmZpInfo({ state: "err", msg: `Chyba: ${data?.error || ("HTTP " + r.status)}` });
      return;
    }

    const km = Number(data?.km || 0);
    if (!Number.isFinite(km) || km <= 0) {
      setKmZpInfo({ state: "err", msg: "Mapy nevrátily km." });
      return;
    }

    setFormData((prev) => ({
      ...prev,
      prevoz: {
        ...(prev?.prevoz || {}),
        zpPitvaFrom: from,
        zpPitvaTo: to,
        zpMode: true,
          zpHradiKm: km,
          zpKm: km,
      },
    }));

    setKmZpInfo({ state: "ok", msg: `Uloženo: ${km} km` });
  };
  // === /ZP km Mapy ===

const { formData, setFormData, mergeFormData, currentOrderId} = useFormData();

  
  // __DBG_REZIM__: sleduje kdo ti přepisuje ZP zpět na komerční
  const __dbgPrevRezimRef = useRef(undefined);
  useEffect(() => {
    const r = String(formData?.prevoz?.rezim ?? "");
    const prev = __dbgPrevRezimRef.current;
    if (prev !== undefined && prev !== r) {
      console.log("[PREVOZ][rezim change]", prev, "->", r, "prevoz=", formData?.prevoz);
    }
    __dbgPrevRezimRef.current = r;
  }, [formData?.prevoz?.rezim]);
// ---- KONFIG (můžeš kdykoli přepsat v UI) ----
  const prevozCfg = formData?.prevoz || {};
  const baseAdresa = pickStr(prevozCfg?.baseAdresa, "Český Krumlov, Pod Skalkou 525");
  const ckChladAdresa = pickStr(prevozCfg?.ckChladAdresa, "Český Krumlov, Hřbitovní 149");
  const cbKrematoriumAdresa = pickStr(prevozCfg?.cbKrematoriumAdresa, "Krematorium České Budějovice");
  const autoCalc = prevozCfg?.autoCalc !== false;

  // ===== ZP PITVA MODE (úmrtí -> pitva) =====
  const zpMode = !!prevozCfg?.zpMode; // když true, kmZP bere zpKm (místo checkboxů)
  const zpOd = String(prevozCfg?.zpOd || "").trim();
  const zpKam = String(prevozCfg?.zpKam || "").trim();
  const zpKm = Number(prevozCfg?.zpKm || 0);

  const setPrevozCfg = (patch) => mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), ...(patch || {}) } });

  const calcZPKm = async () => {
    const od = String((prevozCfg?.zpOd ?? "")).trim();
    const kam = String((prevozCfg?.zpKam ?? "")).trim();
    if (!od || !kam) return;
    try {
      const r = await fetch(apiUrl("/api/vypocitej-km"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ umrtiAddress: od, toAddress: kam, routeType: "car_fast" }),
      });
      const j = await r.json().catch(() => ({}));
      if (j?.ok) {
        const km = Number(j.kmCeil ?? j.km ?? 0) || 0;
        setPrevozCfg({ zpMode: true, zpKm: floorKm(km) });
      }
    } catch (e) {
      // neblokujeme UI
    }
  };
    const spz = pickStr(prevozCfg?.spz, "");
    // ===== REŽIM PŘEVOZU (Komerční vs. ZP) =====
    const rezim = String(prevozCfg?.rezim || "komercni"); 
      const isZPMode = String(rezim || "").toLowerCase().includes("zp") || String(rezim || "").toLowerCase().includes("poj");
// komercni | zp
    const setRezim = (r) => {
        const rr = String(r || "komercni").toLowerCase();

        // 1) UI (okamžitě přepnout v aktuální zakázce)
        try {
          setFormData?.((prev) => {
            const cur = (prev && prev.prevoz) || {};
            return { ...(prev || {}), prevoz: { ...(cur || {}), rezim: rr, rezimZP: rr } };
          });
        } catch (e) {}

        // 2) Persist per zakázka (uložit do storage/serveru přes mergeFormData)
        try {
          const pre = formData?.prevoz || {};
          mergeFormData?.({ prevoz: { ...(pre || {}), rezim: rr, rezimZP: rr } });
        } catch (e) {}

        try { recalcAll?.(); } catch (e) {}
      };
    // ===== /REŽIM =====



  // kolik řádků tras chceme (default 5 – můžeš navýšit)
  const rows = Number.isFinite(Number(prevozCfg?.rows)) ? Math.max(3, Number(prevozCfg.rows)) : 5;

  const prevozy = useMemo(() => ensureN(formData, rows), [formData?.prevozy, formData?.prevoz, rows]);
  const [local, setLocal] = useState(prevozy);


  // ✅ guard proti autosave loopu
  const __lastPrevozAutoSaveRef = useRef("");
  // === PREVOZ_SYNC_ON_OPEN + AUTOSAVE ===
  const __orderId =
    String(
      currentOrderId ||
      formData?.meta?.orderId ||
      formData?.orderId ||
      formData?.zakazkaId ||
      formData?.id ||
      ""
    ).trim();

  const __readPrevozFromCtx = () => {
  // ✅ vždy vrať ARRAY (sjednocený tvar). Legacy "prevoz" (objekt) se nasaje přes ensureN().
  try {
    return ensureN(formData, rows);
  } catch (e) {
    return Array.isArray(prevozy) ? prevozy : [];
  }
};
useEffect(() => {
    if (!__orderId) return;
    try { setLocal(Array.isArray(__readPrevozFromCtx()) ? __readPrevozFromCtx() : []); } catch {}
  }, [__orderId]);

  
useEffect(() => {
  if (!__orderId) return;

  // ✅ ukládej jen když se data fakt změnila
  const snap = (() => {
    try { return JSON.stringify(Array.isArray(local) ? local : []); } catch (e) { return ""; }
  })();
  if (snap && snap === __lastPrevozAutoSaveRef.current) return;

  const t = setTimeout(() => {
    const snap2 = (() => {
      try { return JSON.stringify(Array.isArray(local) ? local : []); } catch (e) { return ""; }
    })();
    if (snap2 && snap2 === __lastPrevozAutoSaveRef.current) return;

    __lastPrevozAutoSaveRef.current = snap2 || "__empty__";

    try {
      mergeFormData(
      {
        prevozy: Array.isArray(local) ? local : [],
        // legacy kompatibilita: "prevoz" je objekt (první řádek)
        prevoz: (Array.isArray(local) && local[0] && typeof local[0] === "object") ? local[0] : {},
      },
      "prevoz:auto"
    );
    } catch {}
  }, 350);

  return () => clearTimeout(t);
}, [__orderId, local]);
// ✅ Když přepneš zakázku, musíme přenačíst lokální tabulku tras (local) z nových dat
    // ZakKey bereme z několika možných polí (dle toho, jak to máš v systému zakázek)
    const zakKey = String(
      formData?.aktivniZakazkaId ??
      formData?.activeZakazkaId ??
      formData?.zakazkaId ??
      formData?.currentZakazkaId ??
      formData?.id ??
      formData?.uuid ??
      ""
    );

    const lastZakKeyRef = useRef(zakKey);

    useEffect(() => {
      if (lastZakKeyRef.current !== zakKey) {
        setLocal(prevozy);
        lastZakKeyRef.current = zakKey;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zakKey, prevozy]);
  // ===== Helpers pro práci s tabulkou tras (aby šlo psát + fungovala tlačítka) =====
  const setAll = (nextArr) => {
    const arr = Array.isArray(nextArr) ? nextArr : [];
    setLocal(arr);

    // uložit i do zakázky (formData.prevozy), aby se to neztratilo
    try {
      setFormData?.((prev) => ({ ...(prev || {}), prevozy: arr }));
    } catch (e) {}

    try {
      mergeFormData?.({ prevozy: arr });
    } catch (e) {}
  };

  const setOne = (idx, patch) => {
    setLocal((prev) => {
      const cur = Array.isArray(prev) ? prev : [];
      const next = cur.map((r, i) => (i === idx ? { ...(r || {}), ...(patch || {}) } : r));

      try { setFormData?.((p) => ({ ...(p || {}), prevozy: next })); } catch (e) {}
      try { mergeFormData?.({ prevozy: next }); } catch (e) {}

      return next;
    });
  };
  // ===== /Helpers =====
    // Celkem km = součet km z tabulky tras (toleruje čárku i tečku)
    const totalKm = useMemo(() => {
      const arr = Array.isArray(local) ? local : [];
      let sum = 0;

      for (const row of arr) {
        const raw = row?.km;
        const n = (typeof raw === "number")
          ? raw
          : Number(String(raw ?? "").replace(",", ".").trim());

        if (Number.isFinite(n)) sum += n;
      }

      return sum;
    }, [local]);


  
  // ZP km (může být z Mapy.cz nebo ručně) – bereme z formData.prevoz a tolerujeme čárku
  const kmZP = useMemo(() => {
    const pre = formData?.prevoz || {};
    const raw = pre?.zpKmBill ?? pre?.zpHradiKm ?? pre?.zpKm ?? pre?.kmZP ?? 0;
    const n = typeof raw === "number"
      ? raw
      : Number(String(raw ?? "").replace(",", ".").trim());
    return Number.isFinite(n) ? n : 0;
  }, [
    formData?.prevoz?.zpKmBill,
    formData?.prevoz?.zpHradiKm,
    formData?.prevoz?.zpKm,
    formData?.prevoz?.kmZP,
  ]);

      

  // === AUTO: sync doprava_1km (useEffect) ===
  useEffect(() => {
    try {
      const pre2 = formData?.prevoz || {};
      const autoDoprava = (pre2?.autoDoprava1km !== false); // default ON
      if (!autoDoprava) return;

      const rez2 = String(pre2?.rezim || "komercni").toLowerCase();
      const isZP2 = rez2.includes("zp") || rez2.includes("poj");

      // km do služby doprava_1km:
      // - v ZP: účtuje se jen objednavatel (total - ZP)
      // - v komerci: účtuje se total
      
        const total = floorKm(totalKm || 0);

        // ✅ TDZ fix: tady NESMÍME sahat na kmZPEffective (je definované až níž).
        // Vezmeme ZP nárok z prevoz (drží ho sync z přepínače 1×/2×).
        const zpNoBill = floorKm(
          Number(pre2?.zpHradiKm ?? pre2?.zpKm ?? pre2?.kmZP ?? 0) || 0
        );

        const kmBill = isZP2
          ? floorKm(Math.max(0, (Number(total || 0) || 0) - (Number(zpNoBill || 0) || 0)))
          : total;


      setFormData?.((prev) => {
        const cur = prev || {};
        const sl = Array.isArray(cur.sluzby) ? cur.sluzby : [];

        const id = "doprava_1km";
        const has = sl.some((r) => String(r?.id || "") === id);

        const nextSl = sl.map((r) => {
          if (String(r?.id || "") !== id) return r;
          // nepiš přes ruční úpravy, pokud si to uživatel vypnul na řádku
          if (r && r.manualQty === true) return r;
          if (r && r.autoQty === false) return r;
          return { ...r, qty: kmBill, autoQty: true };
        });

        // pokud neexistuje, založ ho (uživatel to může případně v Službách odškrtnout)
        if (!has) {
          nextSl.push({
            id,
            nazev: "Doprava rakve za 1 km",
            jednotka: "km",
            qty: kmBill,
            autoQty: true,
              manualQty: false,
          });
        }

        return { ...cur, sluzby: nextSl };
      });
    } catch (e) {}
  }, [formData?.prevoz?.rezim, formData?.prevoz?.autoDoprava1km, formData?.prevoz?.zpHradiKm, formData?.prevoz?.zpKm, formData?.prevoz?.kmZP, totalKm]);
    // === /AUTO: sync doprava_1km ===
// ✅ Km k účtování (pro doprava_1km + UI)
  // Bere: ZP -> objednavatelKm, Komerční -> totalKm
  const kmKuctovat = useMemo(() => {
    try {
      return calcKmKuctovat(formData, totalKm);
    } catch (e) {
      return floorKm(totalKm || 0);
    }
  }, [formData, totalKm]);
  
    
    // === ZP_NAROK_SWITCH: 1× / 2× nárok ZP (počítá se jen se zesnulým) ===


      const zpNarokModeRaw = String(formData?.prevoz?.zpNarokMode || "roundtrip").toLowerCase();
      // compat: staré "oneway" = "tam"
      const zpNarokMode = (zpNarokModeRaw === "oneway") ? "tam" : (["tam","zpet","roundtrip"].includes(zpNarokModeRaw) ? zpNarokModeRaw : "roundtrip");
      const zpNarokFactor = (zpNarokMode === "roundtrip") ? 2 : 1;
const kmZPEffective = useMemo(() => {
      try {
        const pre = formData?.prevoz || {};
        const modeRaw = String(pre?.zpNarokMode || "roundtrip").toLowerCase();
          const mode = (modeRaw === "oneway") ? "tam" : modeRaw;

        // Z Mapy.cz uložený 1 směr (kmZP držíš v prevoz.zpKm / prevoz.kmZP / prevoz.kmZpBill…)
        // Bereme nejrozumnější zdroj:
        const base = Number(
          pre?.zpKmBill ??
          pre?.zpKm ??
          pre?.kmZP ??
          formData?.prevoz?.kmZP ??
          0
        ) || 0;

        const oneway = floorKm(base);

        // 1× = jeden směr
        // 2× = tam+zpět (nárok se zesnulým)
        if (mode === "roundtrip") return floorKm(oneway * 2);

        // default + případně budoucí "returnonly" = 1×
        return oneway;
      } catch (e) {
        return 0;
      }
    }, [
      formData?.prevoz?.zpNarokMode,
      formData?.prevoz?.zpKmBill,
      formData?.prevoz?.zpKm,
      formData?.prevoz?.kmZP,
    ]);

    // === ZP_NAROK_SYNC_ZPHRADI (AUTO) ===
    useEffect(() => {
      try {
        const pre = formData?.prevoz || {};
        const rez = String(pre?.rezim || "").toLowerCase();
        const isZP = rez.includes("zp");
        if (!isZP) return;

        const want = Number(kmZPEffective || 0) || 0;
        const cur = Number(pre?.zpHradiKm ?? pre?.zpKm ?? pre?.kmZP ?? 0) || 0;

        if (Math.abs(cur - want) > 0.05) {
          mergeFormData?.({ prevoz: { ...pre, zpHradiKm: want } });
        }
      } catch (e) {}
    }, [kmZPEffective, formData?.prevoz?.rezim, formData?.prevoz?.zpHradiKm]);
    // === /ZP_NAROK_SYNC_ZPHRADI ===

    // === /ZP_NAROK_SWITCH ===
// === PITVA (řízení z "Vstupní informace") ===
    const pitvaTyp = String((formData?.vstupni?.pitvaTyp ?? formData?.pitvaTyp ?? "zdravotni") || "zdravotni").toLowerCase();
    const pitvaEnabled = pitvaTyp !== "bez";
    const pitvaIsSoudni = pitvaTyp === "soudni";


    
      
      // === PATOLOGIE_DEFAULT_CB: když je pitva zapnutá, doplň Patologii (kam) na ČB pokud je prázdná ===
      // (pole "Patologie (kam)" je pro výpočet ZP km – bez něj hlásí 'Chybí místo úmrtí nebo patologie')
      const PATOLOGIE_CB = "Nemocnice České Budějovice – Patologie (České Budějovice)";

      useEffect(() => {
        try {
          const pre = formData?.prevoz || {};
          const cur = String(pre?.zpPitvaTo || "").trim();

          if (!pitvaEnabled) return;

          // když je "Jiné zařízení" v Pitvě, nech to na ručním zadání (nedávej ČB)
          const pitvaKam = String(pre?.pitvaKam || "").trim();
          if (pitvaKam === "OTHER" || pitvaKam.startsWith("JINE:")) return;

          // pokud je prázdné, nastav default ČB
          if (!cur) {
            mergeFormData?.({ prevoz: { ...pre, zpPitvaTo: PATOLOGIE_CB } });
          }
        } catch (e) {}
      }, [pitvaEnabled, formData?.prevoz?.pitvaKam]);
      // === /PATOLOGIE_DEFAULT_CB ===
const PITVA_CB = "Nemocnice České Budějovice – pitevna (České Budějovice)";
const pitvaOptions = [
        { value: PITVA_CB, label: "Nemocnice České Budějovice – pitevna (České Budějovice)" },
        { value: "OTHER", label: "Jiné zařízení (ručně zadat adresu)" },
      ];

      const isOtherPitva = () => {
        const cur = String(formData?.prevoz?.pitvaKam || "").trim();
        return cur === "OTHER" || cur.startsWith("JINE:");
      };

      const otherAddrValue = () => {
        const cur = String(formData?.prevoz?.pitvaKam || "").trim();
        if (cur.startsWith("JINE:")) return cur.slice(5).trim();
        return "";
      };

    const isPitvaKamCompatible = (val) => {
      const v = String(val || "");
      if (!v) return true;
      return pitvaIsSoudni ? v.startsWith("soudni") : v.startsWith("zdravotni");
    };

    // === /PITVA ===

    // === PITVA: enforce+default (řízení z Vstupní informace) ===
      useEffect(() => {
        try {
          const pre = formData?.prevoz || {};
          const cur = String(pre?.pitvaKam || "").trim();

          // Bez pitvy: vyčistit
          if (!pitvaEnabled) {
            if (cur) mergeFormData?.({ prevoz: { ...pre, pitvaKam: "" } });
            return;
          }

          // Ruční režim: když začíná "JINE:", nech to na uživateli
          if (cur.startsWith("JINE:")) return;

          // Pitva zapnutá: když je prázdné, nastav default ČB
          if (!cur) {
            mergeFormData?.({ prevoz: { ...pre, pitvaKam: PITVA_CB } });
          }
        } catch (e) {}
      }, [pitvaEnabled]); 
      // === /PITVA: enforce+default ===



// sync při načtení zakázky
  // === Legacy kompatibilita: dopočet zpHradiKm/objednavatelKm z aktuálních BILL hodnot ===
  // normalizovaný režim (kvůli ZP logice) – musí být definovaný dřív než ho použijeme
  const rezimNorm = useMemo(() => {
    const pre = formData?.prevoz || {};
    return String(pre?.rezim || pre?.rezimZP || rezim || "komercni").toLowerCase();
  }, [formData?.prevoz?.rezim, formData?.prevoz?.rezimZP, rezim]);

useEffect(() => {
  const pre = formData?.prevoz || {};
  const rez = String(pre?.rezim || pre?.rezimZP || rezimNorm || "komercni").toLowerCase();
  const isZP = rez === "zp" || rez.includes("poj") || rez.includes("poji");

  const totalBill = floorKm(pre?.totalKmBill ?? pre?.totalKm ?? 0);
  const zpBill = isZP ? floorKm(pre?.zpKmBill ?? pre?.zpHradiKm ?? pre?.zpKm ?? 0) : 0;
  const objed = isZP ? Math.max(0, totalBill - zpBill) : totalBill;

  // jen když se liší (aby to nelítalo do smyčky) + ASI-safe (žádný return na novém řádku)
  if (
    floorKm(pre?.objednavatelKm ?? 0) === objed &&
    floorKm(pre?.zpHradiKm ?? 0) === zpBill &&
    floorKm(pre?.kmUctovat ?? 0) === objed
  ) return;

  setFormData((prev) => ({
    ...(prev || {}),
    prevoz: {
      ...(prev?.prevoz || {}),
      zpHradiKm: zpBill,
      objednavatelKm: objed,
      kmUctovat: objed, // legacy
    },
  }));
}, [
  formData?.prevoz?.totalKm,
  formData?.prevoz?.totalKmBill,
  formData?.prevoz?.zpKm,
  formData?.prevoz?.zpKmBill,
  formData?.prevoz?.zpHradiKm,
  formData?.prevoz?.objednavatelKm,
  formData?.prevoz?.kmUctovat,
  rezimNorm,
  setFormData,
]);
// === /ZP odečet ===

  // 🧠 Auto sestavení základní trasy (firma → úmrtí → chlad → obřad → uložení → firma)
  const autoBuildRoutes = () => {
    try {
      const pre = formData?.prevoz || {};


      const returnToDepot = (pre?.returnToDepot !== false);
        // === ZP režim: pevná trasa (firma -> úmrtí -> patologie -> chlad -> firma) ===
        try {
          const rez = String(pre?.rezim || "komercni").toLowerCase();
          const isZP = rez.includes("zp") || rez.includes("poj");
          if (isZP) {
            const firma = String(pre?.firmaAdresa || formData?.firmaAdresa || formData?.firma?.adresa || baseAdresa || "Český Krumlov, Pod Skalkou 525").trim();
            const umrti = String(__resolveMistoUmrti?.() || "").trim();
            const pitva = String(pre?.zpPitvaTo || "").trim();
            const chlad = String(pre?.ckChladAdresa || ckChladAdresa || "Český Krumlov, Hřbitovní 149").trim();

                    let steps =  [
              { label: "Firma → úmrtí", od: firma, kam: umrti },
              { label: "Úmrtí → patologie", od: umrti, kam: pitva },
              { label: "Patologie → chlad", od: pitva, kam: chlad },
              { label: "Chlad → firma", od: chlad, kam: firma },
            ].filter(x => String(x.od||"").trim() && String(x.kam||"").trim());

            const next = Array.from({ length: rows }, (_, i) => mk(i));
            for (let i = 0; i < Math.min(steps.length, rows); i++) {
              next[i] = { ...next[i], nazev: steps[i].label, popis: steps[i].label, od: steps[i].od, kam: steps[i].kam, km: "" };
            }

            setAll(next);
              if (formData?.prevoz?.autoCalc !== false) recalcAll(next);
return;
          }
        } catch (e) {
          // fallthrough do původní logiky
        }



        // ✅ CHLAD / zázemí (lokálně pro auto trasu – aby nikdy nebyl undefined)
        const chladAddr = String(
          pre?.chladAdresa || pre?.chlad ||
          formData?.chlad || formData?.chladAdresa ||
          "Český Krumlov pod skalkou 525"
        ).trim();
      const kp  = formData?.kremacePohreb || {};
      const obr = formData?.obrad || {};

      // ✅ Úmrtí (TOP-LEVEL u tebe)
      const umrti = String(
        pre?.adresaUmrti || pre?.mistoUmrti ||
        formData?.adresaUmrti || formData?.mistoUmrti ||
        (__resolveMistoUmrti?.() || "")
      ).trim();

      // ✅ Obřad (primárně kremacePohreb.mistoObradu)
      const obrad = String(
          pre?.obradAdresa ||
          kp?.mistoObradu ||
          kp?.adresaObradu ||
          obr?.misto || obr?.vystav || obr?.adresa ||
          ""
        ).trim();
// ✅ Uložení (zatím tolerantní – upřesníme podle klíčů v kremacePohreb)
      const ulozeni = String(
        pre?.ulozeniAdresa ||
        kp?.mistoUlozeni || kp?.mistoPohrebu || kp?.mistoKremace ||
        kp?.hrbitov || kp?.krematorium ||
        formData?.mistoUlozeni ||
        ""
      ).trim();
      // Firma
      const firma = String(
        pre?.firmaAdresa ||
        formData?.firmaAdresa ||
        formData?.firma?.adresa ||
        "Český Krumlov pod skalkou 525"
      ).trim();
        let steps =  [
        { label: "Firma → úmrtí", from: firma, to: umrti },
        { label: "Úmrtí → chlad", from: umrti, to: chladAddr },
        { label: "Chlad → obřad", from: chladAddr, to: obrad },
        { label: "Obřad → uložení", from: obrad, to: ulozeni },
        { label: "Uložení → firma", from: ulozeni, to: firma },
      ];

        if (!returnToDepot) {
          steps = steps.slice(0, -1);
        }


      // vyrobíme řádky podle mk(i) a doplníme dostupné klíče
      const next = steps.map((st, i) => {
        const row = mk(i);
        // různé varianty názvů klíčů (kompatibilita)
        row.popis = st.label;
        row.nazev = row.nazev || st.label;
        row.from = st.from;
        row.to = st.to;
        row.od = row.od || st.from;
        row.do = row.do || st.to;
        return row;
      });

      // doplníme do požadovaného počtu rows (když máš třeba 5 default)
      const pad = Array.from({ length: Math.max(0, rows - next.length) }, (_, k) => mk(next.length + k));
      const merged = next.concat(pad);

      setAll(merged);

        // pokud je autoCalc ON, přepočti hned (nad právě vytvořenými řádky)
        try {
          if (formData?.prevoz?.autoCalc !== false) recalcAll(merged);
        } catch (e) {}
} catch (e) {
      // nic – nechceme pád
    }
  };

  // ➕ Přidat další úsek trasy (jeden řádek navíc)
  const addRow = () => {
    try {
      // vezmi aktuální pole (když je prázdné, vyrob default)
      const cur = Array.isArray(local) ? local : [];
      const next = cur.slice();
      next.push(mk(next.length));
      setAll(next);

        // pokud je autoCalc ON, přepočti hned (nad právě přidaným stavem)
        try {
          if (formData?.prevoz?.autoCalc !== false) recalcAll(next);
        } catch (e) {}
} catch (e) {
      // nic
    }
  };





  const resetAll = () => {
    const next = Array.from({ length: rows }, (_, i) => mk(i));
    setAll(next);
    mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), totalKm: 0 } });
  };

  // 🔄 Přepočítat km (vždy dolů) a uložit do zakázky (formData.prevoz)
  // 🔄 Přepočítat km (vždy dolů) a uložit do zakázky (formData.prevoz)
  const recalcAll = useCallback(async (overrideRows) => {
    try {
      const token = __getToken?.();
      const pre = formData?.prevoz || {};
      const rez = String(pre?.rezim || "komercni").toLowerCase();
      const isZP = rez.includes("zp") || rez.includes("poj");

      const cur0 = Array.isArray(overrideRows) ? overrideRows : local;
      const cur = Array.isArray(cur0) ? (cur0 || []).slice(0, rows) : [];
      const next = [];

      for (let i = 0; i < cur.length; i++) {
        const row = cur[i] || {};
        const od = String(row?.od || row?.from || "").trim();
        const kam = String(row?.kam || row?.to || "").trim();

        let kmVal = Number(row?.km || 0);
        if (!Number.isFinite(kmVal)) kmVal = 0;

        if (od && kam) {
          try {
            const r = await fetch(apiUrl("/api/vypocitej-km"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
              },
              body: JSON.stringify({ umrtiAddress: od, toAddress: kam, routeType: "car_fast" }),
            });
            const j = await r.json().catch(() => ({}));
            if (r.ok && j?.ok) {
              const km = Number(j?.kmCeil ?? j?.km ?? 0) || 0;
              kmVal = floorKm(km);
            }
          } catch (e) {
            // necháme kmVal jak je (0 nebo ruční)
          }
        }

        next.push({ ...row, od, kam, km: String(kmVal) });
      }

      // doplň do rows počtu řádků
      if (next.length < rows) {
        const pad = Array.from({ length: rows - next.length }, (_, k) => mk(next.length + k));
        next.push(...pad);
      }

      // uložit řádky (setAll ukládá i do formData.prevozy)
      setAll(next);

      // součty
      const total = floorKm(next.reduce((acc, r) => acc + (Number(r?.km || 0) || 0), 0));
      const zp = isZP ? floorKm(pre?.zpHradiKm ?? pre?.zpKm ?? 0) : 0;
      const objed = Math.max(0, floorKm(total - zp));

      mergeFormData?.({
        prevoz: {
          ...(pre || {}),
          totalKm: total,
          totalKmBill: total,
          kmKuctovat: floorKm(calcKmKuctovat(formData, total)),
          zpHradiKm: zp,
          objednavatelKm: objed,
          kmUctovat: objed, // legacy kompatibilita
        },
      });
    } catch (e) {
      // nic – nechceme pád
    }
  }, [formData, local, rows, mergeFormData, setAll]);
return (
    <div style={{ maxWidth: 980, margin: "0 auto" }}>
        {/* === ZP: Místo úmrtí → Patologie (km k účtování) === */}
        {__isZP() && (() => {
          const prevoz = formData?.prevoz || {};
            // ✅ lokální výpočet (aby JSX nikdy nepadal na "kmUctovat is not defined")
            const kmUctovat = Number(
              prevoz?.kmUctovat ??
              prevoz?.objednavatelKm ??
              Math.max(0, (Number(totalKm || 0) || 0) - (Number(kmZPEffective || 0) || 0))
            ) || 0;

      const adresaUmrti = String(__resolveMistoUmrti?.() || "").trim();
          const fromResolved = String(adresaUmrti || prevoz?.zpPitvaFrom || __resolveMistoUmrti() || "").trim();

          return (
            <div style={{ marginTop: 12, padding: 12, border: "1px solid #e6e6e6", borderRadius: 12, background: "#fff" }}>
              <div style={{ fontWeight: 900, marginBottom: 8 }}>ZP: Místo úmrtí → Patologie (km k účtování)</div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <div style={{ fontWeight: 800, marginBottom: 4 }}>Místo úmrtí (automaticky)</div>
                  <input
                    value={fromResolved}
                    readOnly
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", background: "#fafafa" }}
                  />
                  <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                    Bere se z Výjezdu / Vstupních informací.
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: 800, marginBottom: 4 }}>Patologie (kam)</div>
                  <input
                    value={String(prevoz?.zpPitvaTo ?? "")}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        prevoz: { ...(prev?.prevoz || {}), zpPitvaTo: e.target.value },
                      }))
                    }
                    placeholder="např. ČB nemocnice – Patologie"
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd" }}
                  />
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
                
      {/* Souhrn km */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:10,marginTop:10,marginBottom:10}}>
        <div style={{border:"1px solid rgba(0,0,0,0.12)",borderRadius:14,padding:10,background:"rgba(255,255,255,0.7)"}}>
          <div style={{fontWeight:900}}>Celkem km</div>
          <div style={{fontSize:20,fontWeight:900}}>{floorKm(kmKuctovat || 0)}</div>
          <div style={{color:"#666",fontWeight:700,fontSize:12}}>auto součet tras</div>
        </div>

        <div style={{border:"1px solid rgba(0,0,0,0.12)",borderRadius:14,padding:10,background:"rgba(255,255,255,0.7)"}}>
          <div style={{fontWeight:900}}>ZP neúčtovat</div>
          <div style={{fontSize:20,fontWeight:900}}>{floorKm(kmZPEffective)}</div>
          <div style={{color:"#666",fontWeight:700,fontSize:12}}>úmrtí → pitva</div>
        </div>

        <div style={{border:"1px solid rgba(0,0,0,0.12)",borderRadius:14,padding:10,background:"rgba(255,255,255,0.7)"}}>
          <div style={{fontWeight:900}}>Účtované km</div>
          <div style={{fontSize:20,fontWeight:900}}>{floorKm(prevoz?.kmUctovat ?? prevoz?.objednavatelKm ?? 0)}</div>
          <div style={{color:"#666",fontWeight:700,fontSize:12}}>objednavatel</div>
        </div>
      </div>

                {/* ZP_NAROK_SWITCH_UI */}
                <div style={{ marginTop: 10, padding: 10, borderRadius: 12, border: "1px solid rgba(0,0,0,0.10)", background: "rgba(255,255,255,0.7)" }}>
                  <div style={{ fontWeight: 900, marginBottom: 6 }}>Nárok ZP (počítá se se zesnulým)</div>
                  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}>
                    
                      <label style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 800 }}>
                        <input
                          type="radio"
                          name="zpNarokMode"
                          checked={zpNarokMode === "tam"}
                          onChange={() => mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), zpNarokMode: "tam" } })}
                        />
                        Se zesnulým: jen tam
                      </label>

                      <label style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 800 }}>
                        <input
                          type="radio"
                          name="zpNarokMode"
                          checked={zpNarokMode === "zpet"}
                          onChange={() => mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), zpNarokMode: "zpet" } })}
                        />
                        Se zesnulým: jen zpět
                      </label>

                      <label style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 800 }}>
                        <input
                          type="radio"
                          name="zpNarokMode"
                          checked={zpNarokMode === "roundtrip"}
                          onChange={() => mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), zpNarokMode: "roundtrip" } })}
                        />
                        Se zesnulým: tam + zpět
                      </label>

                      <span style={{ fontSize: 12, opacity: 0.8 }}>
                        Uloženo z Mapy.cz (1 směr): <b>{floorKm(Number(kmZP || 0) || 0)} km</b> → Nárok: <b>{floorKm(kmZPEffective)} km</b>
                      </span>

                  </div>
                </div>
                {/* /ZP_NAROK_SWITCH_UI */}

<button
                  type="button"
                  onClick={() => {
                    // uložit i from do prevoz (aby bylo vidět co se počítá)
                    setFormData((prev) => ({
                      ...prev,
                      prevoz: { ...(prev?.prevoz || {}), zpPitvaFrom: fromResolved },
                    }));
                    __kmMapyZP({ from: fromResolved, to: String(prevoz?.zpPitvaTo ?? "") });
                  }}
                  disabled={kmZpInfo.state === "saving"}
                  style={{
                    padding: "10px 12px",
                    borderRadius: 12,
                    border: "1px solid #ddd",
                    background: kmZpInfo.state === "saving" ? "#f3f3f3" : "white",
                    cursor: kmZpInfo.state === "saving" ? "not-allowed" : "pointer",
                    fontWeight: 900,
                  }}
                >
                  {kmZpInfo.state === "saving" ? "Počítám…" : "Spočítat z Mapy.cz"}
                </button>
                  {showAdvanced ? (

                <div style={{ fontWeight: 900 }}>
                  kmUctovat: <span style={{ marginLeft: 6 }}>{Number(prevoz?.zpHradiKm ?? prevoz?.zpKm ?? 0) || 0}</span>
                </div>

                  ) : null}
                {kmZpInfo.msg ? (
                  <div style={{ fontWeight: 900, color: kmZpInfo.state === "err" ? "#b00020" : "#1b5e20" }}>
                    {kmZpInfo.msg}
                  </div>
                ) : null}
              </div>
            </div>
          );
        })()}
        {/* === /ZP: Místo úmrtí → Patologie === */}


      <h2 style={{ marginTop: 0 }}>Převoz</h2>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
          <button
            style={{ ...btnStyle, borderColor: rezim === "zp" ? "#66c" : "#444" }}
            type="button"
            onClick={() => setRezim("zp")}
            title="Režim ZP – budeš počítat km s tělem (označíš si je dole)"
          >
            🏥 ZP (pojišťovna)
          </button>

          <button
            style={{ ...btnStyle, borderColor: rezim === "komercni" ? "#6c6" : "#444" }}
            type="button"
            onClick={() => setRezim("komercni")}
            title="Komerční převoz – účtování standardně"
          >
            💰 Komerční
          </button>

          {rezim === "zp" ? (
            <div style={{ alignSelf: "center", fontWeight: 900, opacity: 0.9 }}>
              ZP neúčtovat: {floorKm(kmZPEffective)} / Objednavatel: {floorKm(formData?.prevoz?.objednavatelKm)} / Celkem: {floorKm(formData?.prevoz?.totalKm)}
            </div>
            ) : null}

        {/* ===== ZP PITVA: úmrtí -> pitva (ČB) ===== */}
        {false && (
          <div style={{ ...boxStyle, marginTop: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
              <div style={{ fontWeight: 900 }}>🏥 ZP výpočet (úmrtí → pitva)</div>
              <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={!!formData?.prevoz?.zpMode}
                  onChange={(e) => setPrevozCfg({ zpMode: e.target.checked })}
                />
                <span style={{ opacity: 0.9 }}>Použít km ZP z úmrtí→pitva</span>
              </label>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 160px", gap: 12, marginTop: 10 }}>
              <div>
                <div style={labelStyle}>ZP: místo úmrtí (adresa)</div>
                <input
                  style={inputStyle}
                  value={formData?.prevoz?.zpOd || ""}
                  onChange={(e) => setPrevozCfg({ zpOd: e.target.value })}
                  placeholder="např. Frymburk, ..."
                />
              </div>

              <div>
                <div style={labelStyle}>ZP: pitva (patologie)</div>
                <input
                  style={inputStyle}
                  value={formData?.prevoz?.zpKam || ""}
                  onChange={(e) => setPrevozCfg({ zpKam: e.target.value })}
                  placeholder="např. Patologie ČB, ..."
                />
              </div>

              <div>
                <div style={labelStyle}>Km ZP (auto)</div>
                <div style={{ display: "flex", gap: 8 }}>
                  <input style={{ ...inputStyle, width: "100%" }} value={Number(formData?.prevoz?.zpKm || 0) || ""} readOnly />
                  <button style={{ ...btnStyle, padding: "8px 10px" }} type="button" onClick={calcZPKm} title="Spočítat km pro úmrtí → pitva">
                    🧮
                  </button>
                </div>
                <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                  ZP platí jen úsek <b>úmrtí → pitva</b>. Depo→úmrtí a pitva→depo jde objednavateli.
                </div>
              </div>
            </div>
          </div>
        )}



          {/* ACTION BAR */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              alignItems: "center",
              marginTop: 10,
              padding: "10px 10px",
              border: "1px solid rgba(0,0,0,0.12)",
              borderRadius: 12,
              background: "rgba(255,255,255,0.65)",
            }}
          >
            <button
              style={{ ...btnStyle, fontWeight: 900 }}
              type="button"
              onClick={autoBuildRoutes}
              title="Sestaví trasu: firma → úmrtí → chlad → obřad → uložení → firma"
            >
              🧠 Auto trasa
            </button>

            <button
              style={{ ...btnStyle, borderColor: "#888" }}
              type="button"
              onClick={() => recalcAll()}
              title="Uloží: totalKm + zpHradiKm + objednavatelKm (vždy zaokrouhlené dolů)"
            >
              🔄 Přepočítat km
            </button>

            <button
              style={{ ...btnStyle }}
              type="button"
              onClick={() => mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), autoCalc: !(formData?.prevoz?.autoCalc !== false)  } })}
              title="Když je zapnuto, km se přepočítávají automaticky při změnách tras"
            >
              {formData?.prevoz?.autoCalc !== false ? "⏸ Auto výpočet: ON" : "▶ Auto výpočet: OFF"}
            </button>
            <button
              style={btnStyle}
              onClick={() => setShowAdvanced(v => !v)}
              title="Zobrazí/skryje méně časté přepínače"
            >
              ⚙️ Pokročilé: {showAdvanced ? "ON" : "OFF"}
            </button>
            

              {/* PITVA: UI (řízení z Vstupní informace) */}
              
              
              {pitvaEnabled && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "6px 10px",
                    borderRadius: 10,
                    border: "1px solid rgba(0,0,0,0.12)",
                    background: "rgba(255,255,255,0.9)",
                  }}
                  title="Výběr cíle pitvy je řízen z 'Vstupní informace' (Zdravotní/Soudní/Bez pitvy)."
                >
                  <div style={{ fontWeight: 900 }}>⚰️ Pitva:</div>

                  <select
                    value={isOtherPitva() ? "OTHER" : String(formData?.prevoz?.pitvaKam || "")}
                    onChange={(e) => {
                      const v = String(e.target.value || "");
                      const pre = formData?.prevoz || {};
                      if (v === "OTHER") {
                        mergeFormData?.({ prevoz: { ...pre, pitvaKam: "OTHER" } });
                      } else {
                        mergeFormData?.({ prevoz: { ...pre, pitvaKam: v } });
                      }
                    }}
                    className="vi-select"
                  >
                    <option value="">— vyber —</option>
                    {pitvaOptions.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>

                  {isOtherPitva() && (
                    <div style={{ marginTop: 8 }}>
                      <div className="vi-label">Adresa jiné pitevny</div>
                      <input
                        className="vi-input"
                        placeholder="Zadej adresu pitevny…"
                        value={otherAddrValue()}
                        onChange={(e) => {
                          const txt = String(e.target.value || "").trim();
                          const pre = formData?.prevoz || {};
                          mergeFormData?.({ prevoz: { ...pre, pitvaKam: txt ? ("JINE: " + txt) : "OTHER" } });
                        }}
                      />
                    </div>
                  )}
                </div>
              )}

              {/* /PITVA: UI */}

{showAdvanced && (
              <>


            <button
              style={btnStyle}
              onClick={() => {
                const cur = (formData?.prevoz?.returnToDepot !== false);
                const next = !cur;
                mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), returnToDepot: next } });
}}
              title="Když je OFF, auto trasa NEpřidá poslední úsek zpět do firmy"
            >
              🏠 Návrat do depa: {formData?.prevoz?.returnToDepot !== false ? "ON" : "OFF"}
            </button>
            <button
              style={btnStyle}
              onClick={() => {
                const cur = (formData?.prevoz?.autoDoprava1km !== false); // default ON
                const next = !cur;
                mergeFormData?.({ prevoz: { ...(formData?.prevoz || {}), autoDoprava1km: next } });
              }}
              title="Když je ON, km z Převozu se automaticky propíše do služby doprava_1km (pokud existuje v ceníku)."
            >
              🚚 Doprava 1km AUTO: {formData?.prevoz?.autoDoprava1km !== false ? "ON" : "OFF"}
            </button>



            
              </>
            )}
<button style={btnStyle} type="button" onClick={addRow} title="Přidá další úsek trasy">
              ➕ Přidat trasu
            </button>

            <button style={btnStyle} type="button" onClick={resetAll} title="Smaže všechny trasy v převozu">
              ♻️ Vymazat
            </button>

            <div
              style={{
                marginLeft: "auto",
                fontWeight: 900,
                padding: "6px 10px",
                borderRadius: 10,
                border: "1px solid rgba(0,0,0,0.12)",
                background: "rgba(255,255,255,0.9)",
              }}
              title="Celkový počet km (zaokrouhlený dolů)"
            >
              Celkem km: {floorKm(kmKuctovat || 0)}
            </div>
          </div>
          {/* /ACTION BAR */}

      {/* SPZ + tabulka tras */}
      <div style={{ border: "1px solid rgba(0,0,0,0.12)", borderRadius: 14, padding: 12, background: "rgba(255,255,255,0.7)", marginBottom: 12 }}>
        <div style={{ display: "grid", gridTemplateColumns: "minmax(200px,1fr)", gap: 10, marginBottom: 10 }}>
          <div>
            <div style={{ fontWeight: 800, marginBottom: 4 }}>SPZ vozidla</div>
            <input
              style={{ ...inputStyle, width: "100%" }}
              placeholder="např. 3C4 1234"
              value={String(prevozCfg?.spz || "")}
              onChange={(e) => setPrevozCfg({ spz: e.target.value })}
            />
          </div>
        </div>

        <div style={{ fontWeight: 900, marginBottom: 8 }}>Trasy</div>

        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.12)", width: 70 }}>#</th>
                <th style={{ textAlign: "left", padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.12)", minWidth: 260 }}>Odkud (adresa)</th>
                <th style={{ textAlign: "left", padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.12)", minWidth: 260 }}>Kam (adresa)</th>
                <th style={{ textAlign: "left", padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.12)", width: 120 }}>Km</th>
                <th style={{ textAlign: "left", padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.12)", width: 90 }}>Akce</th>
              </tr>
            </thead>
            <tbody>
              {(Array.isArray(local) ? local : []).slice(0, rows).map((row, i) => (
                <tr key={i}>
                  <td style={{ padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.08)", fontWeight: 900 }}>
                    Převoz {i + 1}
                  </td>

                  <td style={{ padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                    <input
                      style={{ ...inputStyle, width: "100%" }}
                      value={String(row?.od || "")}
                      onChange={(e) => setOne(i, { od: e.target.value })}
                      placeholder="např. Český Krumlov, Pod Skalkou 525"
                    />
                  </td>

                  <td style={{ padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                    <input
                      style={{ ...inputStyle, width: "100%" }}
                      value={String(row?.kam || "")}
                      onChange={(e) => setOne(i, { kam: e.target.value })}
                      placeholder="např. chlad / krematorium / hřbitov"
                    />
                  </td>

                  <td style={{ padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                    <input
                      style={{ ...inputStyle, width: "100%" }}
                      value={String(row?.km || "")}
                      onChange={(e) => setOne(i, { km: e.target.value })}
                      placeholder="0"
                      inputMode="decimal"
                    />
                  </td>

                  <td style={{ padding: "8px 8px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                    <button
                      type="button"
                      onClick={() => setOne(i, { od: "", kam: "", km: "" })}
                      style={{ ...btnStyle, padding: "7px 10px", borderRadius: 10 }}
                      title="Vymazat řádek"
                    >
                      ♻️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: 10, color: "#666", fontWeight: 800, fontSize: 12 }}>
          Tip: piš adresy stejně jako v Mapy.cz. Km se dopočítá automaticky (když je Auto výpočet ON).
        </div>
      </div>


        ✅ Trasy se doplňují z:
        <b> úmrtí</b> (Vstupní informace/Výjezdy),
        <b> místo rozloučení</b> (Kremace/Pohřeb nebo Obřad),
        <b> uložení</b> (Kremace/Pohřeb – krematorium/hřbitov).<br />
        ✅ Total km se ukládá do <b>formData.prevoz.totalKm</b> – pak to napojíme na službu <b>doprava_1km</b>.
      </div>
    </div>
  );
}
